import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FormikInput } from '../../../components';
import AttendanceHashDataTable from './AttendanceHashDataTable';

const AttendanceHashIndex = () => {
  const [hash, setHash] = useState('');
  const [moreData, setMoreData] = useState(false);
  return (
    <>
      <Row className="m-top mb-2">
        <Col>
          <h2 className="m-top mt-1 mb-1">Busqueda de Asistencia por Hash</h2>
        </Col>
      </Row>
      <div className="col-sm-12 MainDivHrCard">
        <Col md={{ span: 3, offset: 9 }} className="mt-2">
          <FormikInput
            label="Hash"
            name="rut"
            placeholder="Ingresa un Hash"
            onChange={data => {
              setHash(data ? data.target.value : '');
              setMoreData(!moreData);
            }}
            value={hash}
          />
        </Col>
        <AttendanceHashDataTable moreData={moreData} customParams={{ filter_by_hash: hash }} />
      </div>
    </>
  );
};

export default AttendanceHashIndex;
